import React from "react";
import { Tab, Nav } from "react-bootstrap";
import ErrorLog from "../../../component/admin/ErrorLog";
import SubmitTicket from "../../../component/admin/SubmitTicket";
import ContactSupport from "../../../component/admin/ContactSupport";

const Support = () => {
  return (
    <div className="SystemConfig">
      <Tab.Container id="left-tabs-example" defaultActiveKey="logs">
        <Tab.Content>
          <SubmitTicket />
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default Support;
